/* External */
import { useMemo } from 'react';

/* Utils */
import { defaultImages } from '../utils/constants';
import { getImage, resizeImage } from '../utils/imageUtils';

export default function useImageCard({
  images,
  imageSize = 0,
  aspectRatio = '',
  imageToResize,
}) {
  const imageUrl = useMemo(() => (
    imageToResize ? resizeImage(
      imageToResize,
      imageSize,
      aspectRatio,
    ) : getImage(
      images,
      imageSize,
      aspectRatio,
    )
  ), [aspectRatio, imageSize, imageToResize, images]);

  return {
    imageUrl: imageUrl || defaultImages[aspectRatio],
    isDefaultImage: !imageUrl,
  };
}
